import { useTickSoundInteraction } from '@/hooks';
import type { ReactNode } from 'react';

interface ForeignParkingSectionProps {
    title: string;
    ariaLabel: string;
    children: ReactNode;
}

export default function ForeignParkingSection({ title, ariaLabel, children }: ForeignParkingSectionProps) {
    const { playTick } = useTickSoundInteraction();

    return (
        <div
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    playTick();
                    e.preventDefault();
                    e.stopPropagation();
                }
            }}
            tabIndex={2}
            data-interactive
            aria-label={ariaLabel}
            className="focus-border flex w-full flex-col gap-[calc(28*var(--vh-unit))]"
        >
            <div className="w-full rounded-[calc(8*var(--vh-unit))] bg-[var(--color-bg-parking-foreign-section-header)] px-[calc(24*var(--vw-unit))] py-[calc(16*var(--vh-unit))]">
                <h2 className="text-[calc(28*var(--vh-unit))] leading-[calc(30*var(--vh-unit))] font-bold tracking-[calc(-0.56*var(--vh-unit))] text-[color:var(--color-text-black)] uppercase">
                    {title}
                </h2>
            </div>
            <div className="flex w-full flex-col gap-[calc(20*var(--vh-unit))] px-[calc(24*var(--vw-unit))]">
                {children}
            </div>
        </div>
    );
}
